/**
 * Constants used across the page manager section services
 */

export const SECTION_CSV_HEADERS = [
  'Admin title',
  'Header label',
  'Type',
  'Label (content list)',
  'Content list (content list)',
  'Content reference type (ref list)',
  'Content filters (ref list)',
  'Sort type',
  'Web link label',
  'Web link url',
  'App link label',
  'App link url',
  'Display mode',
  'Enable section',
  'RC Inverse Rule',
  'RC Users affinity',
  'Targeted RC',
  'TenureRules inverse rules',
  'TenureRules Ranges (days)',
  'Has Watched Rules - inverse rule',
  'Has Watched Title',
  'Entitlement Rules - inverse rule',
  'Entitlements',
  'User View Count Rules - inverse rule',
  'User View Count Threshold',
]
